import React from 'react';
import { ButtonWithText } from '../ButtonWithText';
import { useCSVDownloader } from 'react-papaparse';
import { toast } from 'react-hot-toast';

interface DownloadCSVButtonProps<T> {
  fileName: string;
  file: T;
  title?: string;
  toastMessage?: string;
}

export const DownloadCSVButton = <T,>({
  fileName,
  file,
  title,
  toastMessage
}: DownloadCSVButtonProps<T>) => {
  const { CSVDownloader } = useCSVDownloader();

  return (
    <CSVDownloader
      filename={fileName}
      bom={true}
      header={true}
      config={{
        delimiter: ';'
      }}
      data={() => {
        toast.success(toastMessage ? toastMessage : 'Modèle téléchargé 📔');
        return file;
      }}
    >
      <ButtonWithText
        variant={'primaryBlue'}
        content={title ? title : 'Téléchargez le modèle .CSV'}
        iconColor={'#FFF'}
        icon={'Download'}
        onClick={null}
      />
    </CSVDownloader>
  );
};
